import { render } from "./DashboardModule.vue?vue&type=template&id=50faf12b"
import script from "./DashboardModule.vue?vue&type=script&lang=js"
export * from "./DashboardModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__